import React, { useEffect, useRef } from 'react';
import { connect } from "react-redux";

import * as SearchActions from './actions';

import TokensList from '../token/TokensList'

import Box from '../components/Box';
import Button from '../components/Button';

import '../css/Input.css';

const SearchPage = ({
  dispatch,
  handleChange,
  handleSubmit,
  handleClear,
  jabraTokens,
  fetched,
  navBarHeight,
  navBarActive
}) => {
  const ref = useRef(null);

  var searchPageHeight = null;
  const style = navBarActive ? { background: '#F8F8F8' } : { top: navBarHeight, background: '#F8F8F8' };
  const yIncrement = 64; // the div element of the top returns the heigh without the top margin.

  useEffect(() => {
    if (ref !== null && fetched) {
      searchPageHeight = ref.current.getBoundingClientRect().height + yIncrement;
      dispatch(notifySearchPageHeight(searchPageHeight));
    }
  }, [fetched])

  return (
    <div ref={ref}>
      <Box className='relative ma4 pv3 ph4' style={style}>
        <div>
          <div className='flex flex-wrap items-center'>
            <h1 className='times-new-roman fw4 charcoal mb2 f3 greenmod'>Search tokens</h1>
          </div>
          <div className=''>You can search tokens for any addresses.</div>
          <p className='fw6 mt1 ml3-ns w-100'></p>
          <form onSubmit={handleSubmit}>
            <label className="Label"></label>
            <input
              type="text"
              placeholder="Address"
              name="addressOfOwner"
              onChange={handleChange}
              className='v-mid focus-outline mb1'
              style={{padding: '1px', borderColor: '#ffffff', width: '50%', maxWidth: "400px" }}
            />
            <Button type="submit" className='mb1' style={{ fontWeight: '400' }}>Search</Button>
          </form>
          <form onSubmit={handleClear}>
            <Button type="clear" className='mv1' style={{ fontWeight: '400' }}>Clear Result</Button>
          </form>
        </div>
      </Box>
      <TokensList
        style={style}
        jabraTokens={jabraTokens}
      />
    </div>
  );
}

const notifySearchPageHeight = searchPageHeight => {
  return {
    type: SearchActions.SEARCHPAGE_HEIGHT_DETERMINDED,
    searchPageHeight: searchPageHeight
  }
}

const mapStateToProps = state => ({
  fetched: state.search.fetched,
  navBarHeight: state.navigation.navBarHeight,
  navBarActive: state.navigation.navBarActive
});

export default connect(mapStateToProps)(SearchPage);
